module.exports = __webpack_public_path__ + "img/dienteCepillo.f5e3e654.svg";